import { FC } from 'react';
import { SelectedEquipmentInfoProps } from '../types';
import cx from 'classnames';
import styles from './HeaderSelectedEquipment.module.scss';
import { Conditional } from '../../../common';

export const SelectedEquipment: FC<SelectedEquipmentInfoProps> = ({
  imageURL,
  assetId,
  model,
  serialNumber,
  isMobile,
  imgComp: Image = 'img',
  subLabel,
  isFeatureFlag
}) => {
  const isMobileSearchClassnames = {
    'cat-u-theme-typography-label': subLabel
  };
  const isSerialNumber = isFeatureFlag ? serialNumber : assetId || serialNumber;

  return (
    <>
      <Conditional test={!!imageURL}>
        <div
          className={cx(
            'ms-1',
            styles['header__selected-equipment-img-container']
          )}
        >
          <Image
            src={`${imageURL}?wid=76&hei=58&fmt=png-alpha`}
            height={58}
            width={76}
            loading="lazy"
            alt={model}
            className={cx(styles['header__selected-equipment-img'])}
          />
        </div>
      </Conditional>

      <div className={cx('text-start overflow-hidden', { 'me-2': !isMobile })}>
        <p
          className={cx(
            'm-0 text-truncate',
            isMobileSearchClassnames,
            styles['header__selected-equipment-title'],
            { 'cat-u-theme-typography-label': !isMobile }
          )}
        >
          {model}
        </p>
        <Conditional test={!!serialNumber}>
          <p
            className={cx(
              'm-0 text-truncate cat-u-theme-typography-footnote',
              styles['header__selected-equipment-subtitle']
            )}
          >
            {isSerialNumber}
          </p>
        </Conditional>
      </div>
    </>
  );
};
